import React from 'react';

import { TResourceGroupItem } from '@/console/features/groups/components/groups.types';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';
import { DevicesIcon } from '@/shared/assets/icons/devices-icon';
import { DocumentsIcon } from '@/shared/assets/icons/documents-icon';
import { FolderIcon } from '@/shared/assets/icons/folder-icon';
import { GatewayIcon } from '@/shared/assets/icons/gateway-icon';
import { LicenseIcon } from '@/shared/assets/icons/license-icon';
import { PipelinesIcon } from '@/shared/assets/icons/pipelines-icon';
import { ProjectsIcon } from '@/shared/assets/icons/projects-icon';
import { SettingsIcon } from '@/shared/assets/icons/settings-icon';
import { UserIcon } from '@/shared/assets/icons/user-icon';
import { UserRoleIcon } from '@/shared/assets/icons/user-role-icon';
import { VaultIcon } from '@/shared/assets/icons/vault-icon';
import { TEntityActionType } from '@/shared/features/ability/hooks/use-user-ability/use-user-ability.types';

export const useGroupedResourceElements = () => {
  const getIconForResource = (
    resourceTypename: TResourceGroupItem['__typename'],
    iconProps?: TBaseIcon,
  ) => {
    switch (resourceTypename) {
      case 'GatewayResponseType':
        return <GatewayIcon {...iconProps} />;
      case 'DeviceResponseType':
        return <DevicesIcon {...iconProps} />;
      case 'ProjectResponseType':
        return <ProjectsIcon {...iconProps} />;
      case 'UserResponseType':
        return <UserIcon {...iconProps} />;
      case 'UserRoleResponseType':
        return <UserRoleIcon {...iconProps} />;
      case 'DocumentResponseType':
        return <DocumentsIcon {...iconProps} />;
      case 'VaultResponseType':
        return <VaultIcon {...iconProps} />;
      case 'LicenseResponseType':
        return <LicenseIcon {...iconProps} />;
      case 'PipelineConfigurationResponseType':
        return <PipelinesIcon {...iconProps} />;
      case 'IntegrationResponseType':
        return <SettingsIcon {...iconProps} />;
      case 'ResourceGroupResponseType':
      default:
        return <FolderIcon {...iconProps} />;
    }
  };

  const getPermissionEntityForResource = (
    resourceTypename: TResourceGroupItem['__typename'],
  ): TEntityActionType | undefined => {
    switch (resourceTypename) {
      case 'GatewayResponseType':
        return 'Gateway';
      case 'DeviceResponseType':
        return 'Device';
      case 'ProjectResponseType':
        return 'Project';
      case 'UserResponseType':
        return 'Ident';
      case 'UserRoleResponseType':
        return 'Ident';
      case 'DocumentResponseType':
        return 'Document';
      case 'VaultResponseType':
        return 'Vault';
      case 'LicenseResponseType':
        return 'License';
      case 'PipelineConfigurationResponseType':
        return 'Pipeline';
      case 'ResourceGroupResponseType':
        return 'ResourceGroup';
      case 'IntegrationResponseType':
      default:
        return undefined;
    }
  };

  return {
    getIcon: getIconForResource,
    getPermissionEntity: getPermissionEntityForResource,
  };
};
